module.exports = __webpack_public_path__ + "static/media/ascenseur.b77711fc.svg";